const getClientId = () => process.env.NEXT_PUBLIC_IDENTITY_CLIENT_ID;

export default getClientId;
